import React, { useRef, useEffect } from "react";

const RichEditor = ({ value, onChange, placeholder = "Start writing..." }) => {
  const editorRef = useRef(null);

  useEffect(() => {
    if (editorRef.current && editorRef.current.innerHTML !== value) {
      editorRef.current.innerHTML = value || "";
    }
  }, []);

  const exec = (cmd, val = null) => {
    document.execCommand(cmd, false, val);
    editorRef.current.focus();
  };

  const handleInput = () => {
    onChange(editorRef.current.innerHTML);
  };

  const toolbarBtns = [
    { label: "B",  title: "Bold",        action: () => exec("bold"),           cls: "font-bold" },
    { label: "I",  title: "Italic",      action: () => exec("italic"),         cls: "italic" },
    { label: "U",  title: "Underline",   action: () => exec("underline"),      cls: "underline" },
    { label: "S",  title: "Strike",      action: () => exec("strikethrough"),  cls: "line-through" },
    { label: "H1", title: "Heading 1",   action: () => exec("formatBlock","h1"), cls: "font-black text-[11px]" },
    { label: "H2", title: "Heading 2",   action: () => exec("formatBlock","h2"), cls: "font-bold text-[11px]" },
    { label: "H3", title: "Heading 3",   action: () => exec("formatBlock","h3"), cls: "font-semibold text-[11px]" },
    { label: "P",  title: "Paragraph",   action: () => exec("formatBlock","p"),  cls: "" },
    { label: "• List",  title: "Bullet List", action: () => exec("insertUnorderedList"), cls: "" },
    { label: "1. List", title: "Numbered List", action: () => exec("insertOrderedList"), cls: "" },
    { label: "🔗 Link",  title: "Insert Link", action: () => { const url = prompt("Enter URL:","https://"); if(url) exec("createLink", url); }, cls: "" },
    { label: "— Divider", title: "Horizontal Rule", action: () => exec("insertHorizontalRule"), cls: "" },
    { label: "Left",   title: "Align Left",   action: () => exec("justifyLeft"),   cls: "text-[11px]" },
    { label: "Center", title: "Align Center", action: () => exec("justifyCenter"), cls: "text-[11px]" },
    { label: "Right",  title: "Align Right",  action: () => exec("justifyRight"),  cls: "text-[11px]" },
    { label: "Clear",  title: "Remove Format",action: () => exec("removeFormat"),  cls: "text-gray-400 text-[11px]" },
  ];

  return (
    <div className="border border-gray-200 rounded-xl overflow-hidden focus-within:border-[#e84fa5] transition">
      {/* Toolbar */}
      <div className="flex flex-wrap gap-1 p-2 bg-gray-50 border-b border-gray-200">
        {toolbarBtns.map((btn) => (
          <button key={btn.label} type="button" title={btn.title}
            onMouseDown={(e) => { e.preventDefault(); btn.action(); }}
            className={`px-2.5 py-1.5 text-[12px] rounded-md border border-gray-200 bg-white hover:bg-pink-50 hover:border-[#e84fa5] hover:text-[#e84fa5] transition whitespace-nowrap ${btn.cls}`}>
            {btn.label}
          </button>
        ))}
      </div>
      {/* Editable area */}
      <div
        ref={editorRef}
        contentEditable
        onInput={handleInput}
        suppressContentEditableWarning
        className="min-h-[280px] p-5 text-[14px] text-gray-700 outline-none blog-content"
        style={{ lineHeight: 1.85 }}
        data-placeholder={placeholder}
      />
    </div>
  );
};

export default RichEditor;
